<template>
    <div class="content">
        <div class="title">中国网点</div>
        <div class="dot-list">
            <div v-for="(item, index) in typeArr" :class="selectType===item.type?'active':''" :key="index" @click="switchTab(item.type)">{{item.title}}</div>
        </div>
        <div class="card-list">
            <div v-for="(item, index) in cardList" :key="index" class="single-card" :style="{marginRight:(index+1)%3===0?'0px':'20px'}">
                <div class="info">
                    <div class="card-title">{{item.name}}</div>
                    <div class="address-phone"><img src="../../assets/weizhi.png"><span>{{item.address}}</span></div>
                    <div class="address-phone"><img src="../../assets/rexian.png"><span>{{item.tel}}</span></div>
                </div>
                <div class="btn" @click="go(item)">点击查看></div>
                
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            typeArr:[
                {title:'华北',type:0},
                {title:'华东',type:1},
                {title:'华南',type:2},
                {title:'华中',type:3},
                {title:'西南&西北',type:4},
                {title:'其他地区',type:5},
            ],
            selectType:0,
            cardList:[
            ]
        }
    },
    mounted() {
        this.getOrgList();
    },
    methods: {
        switchTab(type){
            this.selectType = type;
            this.cardList = [];
            this.getOrgList();
        },
        go(item){
            window.open(item.redirect_url);
        },
        async getOrgList(){
            const res = await this.$http.get('/api/index/getOrgList',{region:this.selectType});
            res.list&&(this.cardList = res.list);
            this.$forceUpdata();
        },
    },
}
</script>
<style lang="scss" scoped>
.card-list{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    .single-card{
        width:340px;
        border: 1px solid #DBDBDB;
        box-sizing: border-box;
        margin-bottom: 20px;
        .info{
            width:100%;
            box-sizing: border-box;
            padding: 20px 25px;
        }
        .card-title{
            font-family: PingFangSC-Semibold;
            font-size: 18px;
            color: #333333;
            letter-spacing: 0.51px;
            font-weight: 600;
        }
        .address-phone{
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #333333;
            letter-spacing: 0.4px;
            font-weight: 400;
            margin-top: 15px;
            display: flex;
            justify-content: space-between;
            img{
                width:20px;
                height:20px;
                display: block;
            }
            span{
                display: block;
                width: calc(100% - 25px);
            }
        }
        .btn{
            height: 60px;
            line-height: 60px;
            background: #F0F0F0;
            border-top: 1px solid #DBDBDB;
            font-family: PingFangSC-Semibold;
            font-size: 16px;
            color: #235483;
            letter-spacing: 0.45px;
            font-weight: 600;
            text-align: center;
            cursor: pointer;
        }
    }
}
.content{
    width:1120px;
    margin:auto;
    box-sizing: border-box;
    padding: 30px;
    background: #fff;
    .title{
        font-size: 22px;
        color: #235483;
        letter-spacing: 0.62px;
        font-weight: 600;
        margin-bottom: 30px;
    }
    
}
.dot-list{
    display: flex;
    justify-content: space-between;
    // height:50px;
    box-sizing: border-box;
    border-bottom: 1px solid #E2E2E2;
    padding: 15px 45px;
    font-family: PingFangSC-Semibold;
    font-size: 18px;
    color: #235483;
    letter-spacing: 0.51px;
    font-weight: 600;
    div{
        position: relative;
        cursor: pointer;
    }
    .active:before{
        content: '';
        position: absolute;
        width: calc(100% + 30px);
        height: 3px;
        background: #235483;
        bottom: -17px;
        left: -15px;
    }
}
</style>
